module.exports = __webpack_public_path__ + "img/reference-phoenixdx.e7872a63.webp";